import "./AppPTOSchedule.css";

type AppPTOScheduleProps = {
}

export const AppPTOSchedule = ({}: AppPTOScheduleProps) => {
    return (
        <div className="app-pto-schedule">
            <div className="app-pto-schedule-header">
                PTO Schedule
            </div>
            <div className="app-pto-wchedule-content">
                No PTO Schedule yet.
            </div>
        </div>
    )
}